"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateChildren = validateChildren;
exports.validateMaskPlaceholder = validateMaskPlaceholder;
exports.validateMaxLength = validateMaxLength;
var _tinyInvariant = _interopRequireDefault(require("tiny-invariant"));
var _warning = _interopRequireDefault(require("warning"));
var _constants = require("./constants");
// TODO: Fix any type
//@ts-ignore

function validateMaxLength(props) {
  (0, _warning.default)(!props.maxLength || !props.mask, "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.");
}
function validateMaskPlaceholder(props) {
  const {
    mask,
    maskPlaceholder
  } = props;
  (0, _tinyInvariant.default)(!mask || !maskPlaceholder || maskPlaceholder.length === 1 || maskPlaceholder.length === mask.length, 'react-input-mask: maskPlaceholder should either be a single character or have the same length as the mask:\n' + "mask: ".concat(mask, "\n") + "maskPlaceholder: ".concat(maskPlaceholder));
}
function validateChildren(props, inputElement) {
  const conflictProps = _constants.CONTROLLED_PROPS.filter(propId => inputElement && inputElement.props[propId] != null && inputElement.props[propId] !== props[propId]);
  (0, _tinyInvariant.default)(!conflictProps.length, "react-input-mask: the following props should be passed to the InputMask component, not to children: ".concat(conflictProps.join(',')));
}